/**
 * @desc 条件分页查询出库的sn码列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OutMasterSnListRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/getSnPageList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
